import type { AccountStatusMapFunction } from "./AccountStatusMap";

export const ApprovalPending = (): ReturnType<AccountStatusMapFunction> => ({
  title: "Application submitted: In review",
  message: "We may reach out for additional information",
});
